/* unplugin-vue-components disabled */import { render } from "./appeal.vue?vue&type=template&id=0466cfff&scoped=true"
import script from "./appeal.vue?vue&type=script&lang=js"
export * from "./appeal.vue?vue&type=script&lang=js"

import "./appeal.vue?vue&type=style&index=0&id=0466cfff&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0466cfff"]])

export default __exports__